module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="page-header">\n	<h4 class="title">Prizes</h4>\n</div>\n<div class="page-content">\n	<div class="section">\n		<picture>\n			<source srcset="/assets/images/prizes/prize-1.webp" type="image/webp">\n			<img src="/assets/images/prizes/prize-1.jpg" alt="Overall NRL Fantasy 2018 Winner">\n		</picture>\n		<h5>2018 NRL Tipping Overall Winner</h5>\n		<p>\n			As the 2019 NRL Nines tournament is currently not scheduled, the top-ranked overall Tipper will receive a VIP trip for two(2) to the 2019 Harvey Norman NRL All-Stars at AAMI Park. This money-can\'t-buy prize includes two VIP tickets to the event, two(2) nights accommodation, flights from your nearest capital city, food and beverage vouchers and exclusive event activities.\n		</p>\n\n		<h5>2018 NRL Tipping Club Champions</h5>\n		<p>\n			The overall top tipper in each club-supported league will win a signed club jersey.\n		</p>\n		<h5>2018 NRL Tipping Weekly Winners</h5>\n		<p>\n			The Top 5 tippers each round, where eight or more games are played, will receive a KFC voucher valued at $15.\n		</p>\n		<h5>2018 NRL Tipping Streak Winner</h5>\n		<p>The highest streak at the end of the season will win a $300 NRL Shop voucher.</p>\n\n		<h5>Prize Winners</h5>\n		<table>\n			<thead>\n			<tr>\n				<th>Round</th>\n				<th>Winners</th>\n			</tr>\n			</thead>\n			<tbody>\n			';
 if( winners ) { 
__p+='\n				';
 _.each(winners, function( winner_by_round, round ) { 
__p+='\n					<tr>\n						<th>Round '+
((__t=( round ))==null?'':_.escape(__t))+
'</th>\n						<th>\n							';
 _.each(winner_by_round, function( winner ) { 
__p+='\n								<p>'+
((__t=( winner.place ))==null?'':_.escape(__t))+
'. '+
((__t=( winner.firstname ))==null?'':_.escape(__t))+
' '+
((__t=( winner.lastname ))==null?'':_.escape(__t))+
'</p>\n							';
 }); 
__p+='\n						</th>\n					</tr>\n				';
 }); 
__p+='\n			';
 } else{ 
__p+='\n			<tr>\n				<th>\n					....\n				</th>\n				<th>\n					Coming soon\n				</th>\n			</tr>\n			';
 } 
__p+='\n			</tbody>\n		</table>\n	</div>\n</div>';
}
return __p;
};
